import React, { useState } from 'react'
import SimpleReactValidator from 'simple-react-validator';
import { sendContactEmail } from '../../api/emailConfig';
import { toast } from 'react-toastify';


const ContactForm = () => {

    const [forms, setForms] = useState({
        name: '',
        email: '',
        subject: '',
        phone: '',
        message: ''
    });
    const [isLoading, setIsLoading] = useState(false);
    const [validator] = useState(new SimpleReactValidator({
        className: 'errorMessage',
        messages: {
            required: 'Le champ :attribute est requis.',
            email: 'Veuillez saisir une adresse email valide.',
            phone: 'Veuillez saisir un numéro de téléphone valide.',
            alpha_space: 'Le champ :attribute ne peut contenir que des lettres et des espaces.'
        },
        locale: 'fr'
    }));
    const changeHandler = e => {
        setForms({ ...forms, [e.target.name]: e.target.value })
        if (validator.allValid()) {
            validator.hideMessages();
        } else {
            validator.showMessages();
        }
    };

    const submitHandler = async (e) => {
        e.preventDefault();

        if (validator.allValid()) {
            setIsLoading(true);
            validator.hideMessages();

            try {
                const result = await sendContactEmail(forms);

                if (result.success) {
                    toast.success('Votre message a été envoyé avec succès ! Nous vous répondrons dans les plus brefs délais.', {
                        position: "top-right",
                        autoClose: 5000,
                    });

                    setForms({
                        name: '',
                        email: '',
                        subject: '',
                        phone: '',
                        message: ''
                    });
                } else {
                    toast.error('Une erreur est survenue lors de l\'envoi de votre message. Veuillez réessayer.', {
                        position: "top-right",
                        autoClose: 5000,
                    });
                }
            } catch (error) {
                console.error('Erreur:', error);
                toast.error('Une erreur inattendue est survenue. Veuillez réessayer plus tard.', {
                    position: "top-right",
                    autoClose: 5000,
                });
            } finally {
                setIsLoading(false);
            }
        } else {
            validator.showMessages();
        }
    };

    return (
        <form onSubmit={(e) => submitHandler(e)} className="contact-validation-active" >
            <div className="row">
                <div className="col col-lg-6 col-12">
                    <div className="form-field">
                        <input
                            value={forms.name}
                            type="text"
                            name="name"
                            onBlur={(e) => changeHandler(e)}
                            onChange={(e) => changeHandler(e)}
                            placeholder="Votre nom" />
                        {validator.message('name', forms.name, 'required|alpha_space')}
                    </div>
                </div>
                <div className="col col-lg-6 col-12">
                    <div className="form-field">
                        <input
                            value={forms.email}
                            type="email"
                            name="email"
                            onBlur={(e) => changeHandler(e)}
                            onChange={(e) => changeHandler(e)}
                            placeholder="Votre email" />
                        {validator.message('email', forms.email, 'required|email')}
                    </div>
                </div>
                <div className="col col-lg-6 col-12">
                    <div className="form-field">
                        <input
                            value={forms.phone}
                            type="tel"
                            name="phone"
                            onBlur={(e) => changeHandler(e)}
                            onChange={(e) => changeHandler(e)}
                            placeholder="Votre téléphone" />
                        {validator.message('phone', forms.phone, 'required|phone')}
                    </div>
                </div>
                <div className="col col-lg-6 col-12">
                    <div className="form-field">
                        <select
                            onBlur={(e) => changeHandler(e)}
                            onChange={(e) => changeHandler(e)}
                            value={forms.subject}
                            type="text"
                            name="subject">
                            <option value="">Sélectionner un service</option>
                            <option value="Coach en éducation canine">Coach en éducation canine</option>
                            <option value="Comportementaliste canin">Comportementaliste canin</option>
                        </select>
                        {validator.message('subject', forms.subject, 'required')}
                    </div>
                </div>
                <div className="col col-lg-12 col-12">
                    <textarea
                        onBlur={(e) => changeHandler(e)}
                        onChange={(e) => changeHandler(e)}
                        value={forms.message}
                        name="message"
                        rows="5"
                        placeholder="Votre message...">
                    </textarea>
                    {validator.message('message', forms.message, 'required')}
                </div>
            </div>
            <div className="submit-area">
                <button
                    type="submit"
                    className="theme-btn"
                    disabled={isLoading}
                >
                    {isLoading ? 'Envoi en cours...' : 'Envoyer le message'}
                </button>
            </div>
        </form >
    )
}

export default ContactForm;